import { Component } from '@angular/core';
import { ModalService } from '@lsq-frontend/common-ui';
import { GetInvoiceImageUrlService } from '@lsq-frontend/remote-services/enterprise/dashboard-services';
import { BaseImagePreviewComponent } from './base-image-preview.component';
import {
    FileType,
    GetInvoiceImageUrlRequest
} from '@lsq-frontend/remote-services/enterprise/common';
import { AlertService } from '@lsq-frontend/angular-shared/features/alert-service';

@Component({
    selector: 'invoice-historical-preview',
    template: `
        <lsq-image-preview
            #imagePreviewElement
            [imageType]="'invoice'"
            [imageUrl]="imageUrl"
            [failed]="failed"
            [filename]="filename"
            [downloadUrl]="downloadUrl"
            [totalPages]="totalPages"
            [page]="currentPage"
            (pageChange)="handlePageChange($event)"
            (fetchImage)="getImageUrl()"
        >
        </lsq-image-preview>
    `
})
export class InvoiceHistoricalPreviewComponent extends BaseImagePreviewComponent {
    public failed = false;

    constructor(
        private _getInvoiceImageUrlService: GetInvoiceImageUrlService,
        private _modalService: ModalService,
        private _alertService: AlertService
    ) {
        super();
    }

    public async getImageUrl(): Promise<void> {
        this.failed = false;

        if (
            !this.imagePreviewElement ||
            !this.imagePreviewElement.maxSize ||
            !this.imagePreviewElement.zoomLevel
        ) {
            return;
        }

        const getInvoiceImageUrlRequest = new GetInvoiceImageUrlRequest({
            invoiceKey: +this.imageId,
            format: FileType.Jpg,
            cropFit: true
        });

        const getInvoiceDownloadUrlRequest = new GetInvoiceImageUrlRequest({
            ...getInvoiceImageUrlRequest,
            format: FileType.Pdf
        });

        const maxWidthAndHeight = Math.floor(
            this.imagePreviewElement.maxSize * this.imagePreviewElement.zoomLevel
        );
        getInvoiceImageUrlRequest.page = this.currentPage || 1;
        getInvoiceImageUrlRequest.zoom = this.imagePreviewElement.zoomLevel * 100;
        getInvoiceImageUrlRequest.width = maxWidthAndHeight;
        getInvoiceImageUrlRequest.height = maxWidthAndHeight;

        try {
            const getInvoiceImageUrlResponse = await this._getInvoiceImageUrlService.executeOnce(
                getInvoiceImageUrlRequest
            );
            if (!getInvoiceImageUrlResponse.url) {
                this._modalService.closeModal();
                this._alertService.info(
                    `Collecting your invoice images can take several minutes. You'll ` +
                        `receive a notification once your images are ready.`
                );
            } else {
                const getInvoiceDownloadUrlResponse = await this._getInvoiceImageUrlService.executeOnce(
                    getInvoiceDownloadUrlRequest
                );
                this.imageUrl = getInvoiceImageUrlResponse.url;
                this.downloadUrl = getInvoiceDownloadUrlResponse.url;
                this.totalPages = getInvoiceImageUrlResponse.pages;
            }
        } catch (_error) {
            this.failed = true;
            throw _error;
        }
    }
}
